export default {
    namespaced: true,
    state: {
        activeFlows: [],
    },
    mutations: {
        setActiveFlows(state, flows) {
            state.activeFlows = flows;
        },
        toggleFlow(state, { flow, checked }) {
            if (checked) {
                if (!state.activeFlows.includes(flow)) {
                    state.activeFlows.push(flow);
                }
            } else {
                state.activeFlows = state.activeFlows.filter((f) => f !== flow);
            }
        },
    },
    getters: {
        getActiveFlows(state) {
            return state.activeFlows;
        },
        isFlowActive: (state) => (flow) => {
            return state.activeFlows.includes(flow);
        },
    },
};
